import type { IStream } from '@nftx/api/dist/ts/assets/Stream';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const useStreamQuery = <T>(
  queryKey: any[],
  fn: () => IStream<T[]>,
  opts?: any
) => {
  const client = useQueryClient();

  return useQuery(
    queryKey,
    () => {
      return new Promise<T[]>((res, rej) => {
        let resolved = false;

        const stream = fn();

        stream.on('error', (e) => {
          rej(e);
        });
        stream.on('data', (data) => {
          if (resolved) {
            client.setQueryData(queryKey, (prevData: T[] | undefined) => {
              return [...(prevData ?? []), ...(data ?? [])];
            });
          } else {
            resolved = true;
            res(data ?? []);
          }
        });
      });
    },
    opts
  );
};

export default useStreamQuery;
